<template>
  <v-dialog v-model="shower" max-width="1500" persistent>
    <v-card color="#525659" class="rounded-lg" max-height="1600">
      <v-card-title class="jusify-center" style="background-color: #ddf7ff">
        <v-btn color="#077893" fab x-small dark @click="close()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div class="ml-3">{{ consentname }}</div>
        <v-spacer></v-spacer>
        <v-tooltip left color="#077893">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              large
              icon
              color="#077893"
              dark
              v-bind="attrs"
              v-on="on"
              @click="downloadPdf"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span v-if="$t('default') === 'th'">ดาวน์โหลดเอกสาร</span>
          <span v-else>Download</span>
        </v-tooltip>
        <v-btn color="error" fab x-small dark @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="black--text text-center pa-0 ma-0">
        <div id="pdf-viewer">
          <iframe
            v-if="FileType == 'pdf'"
            ref="pdfFrame"
            allowfullscreen
            :src="
              'data:application/' +
              FileType +
              ';base64,' +
              file +
              '#toolbar=0&navpanes=0&scrollbar=0'
            "
          ></iframe>
          <iframe
            width="100%"
            height="100%"
            v-else
            ref="pdfFrame"
            allowfullscreen
            :src="
              'data:image/' +
              FileType +
              ';base64,' +
              file +
              '#toolbar=0&navpanes=0&scrollbar=0'
            "
          ></iframe>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "file", "consentname", "filename", "FileType"],
  data: function () {
    return {
      checkType: "",
    };
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("DialogCloseFileUpload");
        }
      },
    },
  },
  methods: {
    close() {
      this.$emit("DialogCloseFileUpload");
    },
    downloadPdf() {

      const iframe = this.$refs.pdfFrame; // เข้าถึงองค์ประกอบ iframe ด้วย $refs
      const pdfUrl = iframe.getAttribute("src"); // ดึงค่า URL ของ PDF จาก iframe
      const fileName = `${this.filename}.pdf`; // กำหนดชื่อไฟล์ที่ต้องการ

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = fileName;
      link.click();
    },
  },
  mounted() {},
};
</script>

<style scoped>
#pdf-viewer {
  width: 100%;
  height: 100%;
}
html,
body,
embed,
iframe,
object {
  margin: 0 !important;
  border: 0;
  width: 100%;
  height: 80vh;
}
</style>